import React, { useEffect, useState } from 'react';
import { List, Button, IconButton, TextField, ListItemText, ListItem, ListItemIcon, ListItemSecondaryAction, Typography, Divider, Box, ListItemButton } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { Delete, CloudDownload, Stop, FiberManualRecord } from '@mui/icons-material';
import { useWebSocketConnection } from '../../services/connectionContext/connectionContext';

export const RadarRecorder = React.memo(({ title, socketUrl }) => {
    const { eventEmitter, webSocketSend } = useWebSocketConnection();
    const socketStatusEvent = 'ON_MESSAGE' + socketUrl + 'status';
    const [description, setDescription] = useState("");
    const [postfix, setPostfix] = useState("");
    const [status, setStatus] = useState({
        downloads: [],
        activate: false,
        process_status: { min_dist: 0, max_dist: 1, frequency_hz: 0 },
        radar_recorder: { description: '', postfix: '', started: true },
    });

    useEffect(() => {
        eventEmitter.on(socketStatusEvent, setStatus);
        return () => {
            eventEmitter.off(socketStatusEvent, setStatus);
        }
    }, [eventEmitter, socketStatusEvent]);

    const handleDownload = (filename) => {
        const hostname = getHostname();
        const backendUrl = `http://${hostname}/download/${filename}`;
        window.open(backendUrl, '_blank');
    };

    function getHostname() {
        var hostname = window.location.hostname;
        if (hostname === "localhost") {
            hostname = socketUrl.replace(/^ws:\/\//, '');
            hostname = hostname.replace(/:\d+$/, '');
        }
        console.info("Der host von welchem die Datei gedownloaded wird lautet: ", hostname);
        return hostname;
    }

    const lst = status.downloads.map((value, i) => (
        <ListItem key={i}>
            <ListItemButton onClick={() => handleDownload(value)}>
                {/* <ListItemLink href={"/download/" + value}> */}
                <ListItemIcon style={{ color: green[300] }}>
                    <CloudDownload />
                </ListItemIcon>
                <ListItemText primary={value} />
                {/* </ListItemLink> */}
            </ListItemButton>
            <ListItemSecondaryAction>
                <IconButton
                    style={{ color: red[300] }}
                    edge="end"
                    aria-label="delete"
                    onClick={() => webSocketSend({ socketUrl: socketUrl, data: { type: "radar:delete_file", payload: value } })} >
                    <Delete />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    ));


    const Btn = () => {
        if (status.radar_recorder.started) {
            return (
                <Button style={{ marginRight: '5%' }} variant="outlined" endIcon={<Stop />} onClick={() => webSocketSend({ socketUrl: socketUrl, data: { type: "radar:record_stop", payload: "" } })}>Stop</Button>
            );
        }
        else {
            return (<Button style={{ marginRight: '5%' }} variant="outlined" endIcon={<FiberManualRecord style={{ color: red[500] }}></FiberManualRecord>}
                onClick={() => webSocketSend({
                    socketUrl: socketUrl, data: {
                        type: "radar:record_start",
                        payload: { description: description, postfix: postfix }
                    }
                })}>Start</Button>)
        }
    }

    return (
        <Box>
            <Typography variant='h6'>
                {title}
            </Typography>

            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={2}
                position="relative"  // Erlaubt absolute Positionierung des Buttons
                width="100%"
            >
                {/* Box für die zentrierten Textfelder */}
                <Box
                    display="flex"
                    gap={2}  // Abstand zwischen den Textfeldern
                    alignItems="center"
                >
                    <TextField
                        label="description"
                        variant="outlined"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />

                    <TextField
                        label="postfix"
                        variant="outlined"
                        value={postfix}
                        onChange={e => setPostfix(e.target.value)}
                    />
                </Box>

                {/* Button am rechten Rand mit 5% Abstand */}
                <Box
                    sx={{
                        position: "absolute",
                        right: "2%"
                    }}>
                    <Btn />
                </Box>
            </Box>

            <br />
            <br />
            <br />

            <Typography variant="h6" >
                List of Data
            </Typography>

            <Divider />

            <div>
                <List height={200}>
                    {lst}
                </List>
            </div>

        </Box>
    )

})

export default RadarRecorder;